
import { Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { ExecutionResult, LoginViewModel, SystemInfo, Token, Tuple, TylerIdModel, TylerIdSettings } from "@tylertech/tyler-api-types";

/**
 * AuthorizeService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class AuthorizeService {
    constructor(private readonly $apiService: ApiService) { }
    
    CanRefreshTokenBeUsed(user: Tuple<string, Date>): Promise<boolean> {
        return this.$apiService.sendAuth("IAuthorizeService/CanRefreshTokenBeUsed", user);
    }
    CheckInsiteNameExists(): Promise<boolean> {
        return this.$apiService.sendAuth("IAuthorizeService/CheckInsiteNameExists");
    }
    ExchangeTylerIdTokenForApiToken(tylerIdValues: Tuple<string, TylerIdModel>): Promise<Token> {
        return this.$apiService.sendAuth("IAuthorizeService/ExchangeTylerIdTokenForApiToken", tylerIdValues);
    }
    GetCloudUrlWithAuthKey(): Promise<string> {
        return this.$apiService.sendAuth("IAuthorizeService/GetCloudUrlWithAuthKey");
    }
    GetESSUserPermissions(pCCUserId: string): Promise<string[]> {
        return this.$apiService.sendAuth("IAuthorizeService/GetESSUserPermissions", pCCUserId);
    }
    GetLoginUrl(): Promise<string> {
        return this.$apiService.sendAuth("IAuthorizeService/GetLoginUrl");
    }
    GetMyOidcToken(): Promise<string> {
        return this.$apiService.sendAuth("IAuthorizeService/GetMyOidcToken");
    }
    GetSystemInfo(): Promise<SystemInfo> {
        return this.$apiService.sendUnauth("IAuthorizeService/GetSystemInfo");
    }
    GetTylerIdSettings(): Promise<TylerIdSettings> {
        return this.$apiService.sendUnauth("IAuthorizeService/GetTylerIdSettings");
    }
    IsLicensed(pKey: string): Promise<boolean> {
        return this.$apiService.sendAuth("IAuthorizeService/IsLicensed", pKey);
    }
    Login(model: LoginViewModel): Promise<ExecutionResult<LoginViewModel>> {
        return this.$apiService.sendAuth("IAuthorizeService/Login", model);
    }
    LoginIntegrationUser(tylerId: TylerIdModel): Promise<ExecutionResult<LoginViewModel>> {
        return this.$apiService.sendAuth("IAuthorizeService/LoginIntegrationUser", tylerId);
    }
    LoginWithTylerId(tylerId: TylerIdModel): Promise<ExecutionResult<LoginViewModel>> {
        return this.$apiService.sendAuth("IAuthorizeService/LoginWithTylerId", tylerId);
    }
    ReloadLoginInfo(): Promise<LoginViewModel> {
        return this.$apiService.sendAuth("IAuthorizeService/ReloadLoginInfo");
    }
}
